module.exports = __webpack_public_path__ + "img/bottom.65e2292d.png";